import client from "directus/src/client";

export const login = async ({ email, password }) => {
  try {
    const response = await client.login(email, password);
    return response;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const logout = async () => {
  try {
    const response = await client.logout();
    return response;
  } catch (error) {
    console.log(error);
    throw error;
  }
};
